export default __webpack_public_path__ + "static/media/google_script.502dcd55.svg";